import { SERVICE_COLLECTION } from '../../../filters/constants';

export const defaultOrderBy = 'CreateDateTimeDesc';

export const baseColumnsDefaultConfigs = [
  { id: 'shipment-number', width: 150 },
  { id: 'order-number', width: 150 },
  { id: 'tracking-number', width: 150 },
  { id: 'service', width: 150 },
  { id: 'recipient', width: 150 },
  { id: 'ship-date', width: 100 },
  { id: 'packing-slip-printed', width: 168 },
  { id: 'label-created', width: 130 },
  { id: 'label-printed', width: 130 },
  { id: 'marketplace-notified', width: 172 },
  { id: 'shipment-email-notified', width: 177 },
  { id: 'delivery-notification', width: 168 },
].map((column, index) => ({
  ...column,
  minWidth: 70,
  index,
  pinned: !!column.pinned,
}));

export const voidedColumnsDefaultConfigs = [
  { id: 'shipment-number', width: 150 },
  { id: 'order-number', width: 150 },
  { id: 'tracking-number', width: 150 },
  { id: 'service', width: 150 },
  { id: 'recipient', width: 150 },
  { id: 'ship-date', width: 100 },
  { id: 'packing-slip-printed', width: 168 },
  { id: 'label-created', width: 130 },
  { id: 'label-printed', width: 130 },
  { id: 'marketplace-notified', width: 172 },
  { id: 'shipment-email-notified', width: 177 },
  { id: 'delivery-notification', width: 168 },
  { id: 'void-type', width: 125 },
].map((column, index) => ({
  ...column,
  minWidth: 70,
  index,
  pinned: !!column.pinned,
}));

export const refundAssistColumnsDefaultConfigs = [
  { id: 'shipment-number', width: 150 },
  { id: 'order-number', width: 150 },
  { id: 'orderDate', width: 107 },
  { id: 'tracking-number', width: 150 },
  { id: 'ship-date', width: 100 },
  { id: 'refund-status', width: 120 },
  { id: 'refund-requested-start-utc', width: 125 },
  { id: 'refund-amount-requested', width: 75 },
  { id: 'refunded-amount', width: 75 },
].map((column, index) => ({
  ...column,
  minWidth: 70,
  index,
  pinned: !!column.pinned,
}));

const otherColumnsDefaultConfigs = [
  { id: 'amount-paid', width: 121 },
  { id: 'assignedTo', width: 150 },
  { id: 'batchName', width: 150 },
  { id: 'carrier', width: 150 },
  { id: 'carrierFee', width: 150 },
  { id: 'city', width: 150 },
  { id: 'company', width: 100, nonsortable: true },
  { id: 'confirmation', width: 122 },
  { id: 'country', width: 90 },
  { id: 'created-date', width: 125 },
  { id: 'customs-forms', width: 142, nonsortable: true },
  { id: 'end-of-day-form', width: 165, nonsortable: true },
  { id: 'forms', width: 100, nonsortable: true },
  { id: 'insurance', width: 102 },
  { id: 'insuranceFee', width: 130 },
  { id: 'intlDuties', width: 94, nonsortable: true },
  { id: 'intlImportFees', width: 94, nonsortable: true },
  { id: 'intlTax', width: 94, nonsortable: true },
  { id: 'orderDate', width: 107 },
  { id: 'package', width: 110 },
  { id: 'paidDate', width: 100 },
  { id: 'postalCode', width: 116 },
  { id: 'provider', width: 93 },
  { id: 'quantity', width: 93 },
  { id: 'rate', width: 100 },
  { id: 'scanToVerifyStatus', width: 140, nonsortable: true },
  { id: SERVICE_COLLECTION, width: 150, nonsortable: true },
  { id: 'shipFrom', width: 120 },
  { id: 'shippingAccount', width: 152, nonsortable: true },
  { id: 'shippingPaid', width: 127 },
  { id: 'source', width: 86 },
  { id: 'state', width: 73 },
  { id: 'store', width: 150 },
  { id: 'taxPaid', width: 94 },
  { id: 'weight', width: 85 },
  { id: 'refund-amount-requested', width: 75 },
  { id: 'refund-completed-utc', width: 125 },
  { id: 'refund-requested-start-utc', width: 125 },
  { id: 'refunded-amount', width: 75 },
  { id: 'refund-status', width: 120 },
  { id: 'void-type', width: 125 },
].map((column) => ({
  ...column,
  minWidth: 70,
}));

export const defaultColumnConfigurations = [...baseColumnsDefaultConfigs, ...otherColumnsDefaultConfigs];
